'use strict';

import React, {Component} from 'react';
import PropTypes from 'prop-types';

import Carousel from "react-bootstrap/Carousel";

import {getBreakpointSize} from "./Utils";

// Bootstrap 4 Multi Slide concept - https://medium.com/wdstack/bootstrap-4-custom-carousel-94a537364fde
class CarouselMulti extends Component {

    constructor(props) {
        super(props);
        this.props = props;

        this.state = {
            breakpoint: getBreakpointSize()
        }
    }

    handleResize = () => {
        let breakpoint = getBreakpointSize();
        if (breakpoint !== this.state.breakpoint) {
            this.setState({ breakpoint: breakpoint });
        }
    };

    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    render() {
        let {children, xl, lg, md, sm, xs, ...componentProps} = this.props;

        let size = this.props[this.state.breakpoint];

        let carousel = [];
        let tempItems = [...children];

        // Breaking array into chunks (array of arrays) - https://scotch.io/courses/the-ultimate-guide-to-javascript-algorithms/array-chunking#toc-looping-through-the-number-of-chunks
        while (tempItems.length > 0) {
            carousel.push(tempItems.splice(0, size));
        }

        let carouselItems = carousel.map((slide, slideIndex) => {
            let innerItems = slide.map((item, itemIndex) => <div style={{width: `${100 / size}%`}} key={itemIndex}>{item}</div>);
            return (
                <Carousel.Item key={slideIndex}>
                    <div className="d-flex flex-row align-self-stretch">
                        {innerItems}
                    </div>
                </Carousel.Item>
            )
        });

        return (
            <Carousel {...componentProps}>
                {carouselItems}
            </Carousel>
        );
    }
}

CarouselMulti.propTypes = {
    xl: PropTypes.number.isRequired,
    lg: PropTypes.number.isRequired,
    md: PropTypes.number.isRequired,
    sm: PropTypes.number.isRequired,
    xs: PropTypes.number.isRequired
}

export default CarouselMulti;